import { Color } from "../Model/Color";
import { ColorRepository } from "../Repository/ColorRepository";



export interface UpdateColorUseCase {
    invoke: (data: Color) => Promise<boolean>;
  }
  
  export class UpdateColor implements UpdateColorUseCase {
    private colorRepo: ColorRepository;
    constructor(_ColorRepo: ColorRepository) {
      this.colorRepo = _ColorRepo;
    }
  
    async invoke(data: Color){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.colorRepo.updateColor(data);
        return update;
    }
  }